import { Model } from "@/models";

export type AutomaticReportTimeSlot = { from: string; to: string };

export default class AutomaticReportCompetitor extends Model {
  static type = "automaticReportCompetitors";

  compare!: boolean;
  comparisonStartsAt!: string | null;
  comparisonEndsAt!: string | null;
  timeSlots!: boolean;
  timeSlotsFilter!: AutomaticReportTimeSlot[] | null;

  createdAt!: Date;
  updatedAt!: Date;
}
